package org.lennycodes.hldi.pages.admin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.icons.fa.FaDeleteLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaPen
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Table
import org.jetbrains.compose.web.dom.Tbody
import org.jetbrains.compose.web.dom.Td
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Th
import org.jetbrains.compose.web.dom.Thead
import org.jetbrains.compose.web.dom.Tr
import org.lennycodes.hldi.backend.db_service.deleteEvent
import org.lennycodes.hldi.data.Event
import org.lennycodes.hldi.styles.AddAdminButtonStyle
import org.lennycodes.hldi.styles.AdminTableStyle
import org.lennycodes.hldi.styles.DeleteIconButtonStyle
import org.lennycodes.hldi.styles.EditIconButtonStyle
import org.lennycodes.hldi.styles.IconButtonStyle
import org.lennycodes.hldi.styles.TableCardStyle
import org.lennycodes.hldi.styles.TableCellStyle
import org.lennycodes.hldi.styles.TableHeaderCellStyle
import org.lennycodes.hldi.styles.TableRowStyle
import org.lennycodes.hldi.styles.UsersTitleStyle

@Composable
fun Events() {

    var selectedEvent by remember { mutableStateOf<Event?>(null) }
    var selectedDeleteEvent by remember { mutableStateOf<Event?>(null) }

    var events by remember { mutableStateOf<List<Event>>(emptyList()) }

    val scope = rememberCoroutineScope()

    var eventDialog by remember { mutableStateOf(false) }
    var refreshKey by remember { mutableStateOf(0) }


    LaunchedEffect(refreshKey) {

        events = AdminRepository.getAllEvents()

    }


    if (eventDialog) {

        AddEventDialog(
            onDismiss = {
                eventDialog = false
            },

            onSuccess = {
                refreshKey++
            }
        )

    }


    selectedEvent?.let { event ->

        EditEventDialog(
            event = event,

            onDismiss = {
                selectedEvent = null
            },

            onSuccess = {

                refreshKey++
                selectedEvent = null

            }
        )

    }


    selectedDeleteEvent?.let { event ->

        ConfirmDeleteEvent(

            event = event,

            onDismiss = {
                selectedDeleteEvent = null
            },

            onConfirm = {

                scope.launch {

                    deleteEvent(event.id)

                    refreshKey++

                    selectedDeleteEvent = null

                }

            }
        )

    }


    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(32.px),

        horizontalAlignment = Alignment.CenterHorizontally,

        verticalArrangement = Arrangement.Top
    ) {


        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(16.px),

            horizontalArrangement = Arrangement.SpaceBetween,

            verticalAlignment = Alignment.CenterVertically
        ) {


            H3(
                attrs = UsersTitleStyle.toAttrs()
            ) {

                Text("Events List")

            }


            Button(

                modifier = Modifier
                    .padding(10.px, 20.px)
                    .then(AddAdminButtonStyle.toModifier()),

                onClick = {

                    eventDialog = true

                }

            ) {

                Text("+ New Event")

            }

        }



        Div(attrs = TableCardStyle.toAttrs()) {


            Table(attrs = AdminTableStyle.toAttrs()) {


                Thead {

                    Tr {

                        listOf(
                            "S/N",
                            "Title",
                            "Date",
                            "Location",
                            "Description",
                            "Registration",
                            "Actions"
                        ).forEach { title ->


                            Th(
                                attrs = Modifier
                                    .padding(14.px,16.px)
                                    .then(TableHeaderCellStyle.toModifier())
                                    .toAttrs()
                            ) {

                                Text(title)

                            }

                        }

                    }

                }



                Tbody {


                    events.forEachIndexed { index, event ->


                        Tr(
                            attrs = TableRowStyle.toAttrs()
                        ) {


                            Td(
                                attrs = Modifier
                                    .padding(14.px,16.px)
                                    .then(TableCellStyle.toModifier())
                                    .toAttrs()
                            ) {

                                Text((index + 1).toString())

                            }



                            Td(
                                attrs = Modifier
                                    .padding(14.px,16.px)
                                    .then(TableCellStyle.toModifier())
                                    .toAttrs()
                            ) {

                                Text(event.title)

                            }



                            Td(
                                attrs = Modifier
                                    .padding(14.px,16.px)
                                    .then(TableCellStyle.toModifier())
                                    .toAttrs()
                            ) {

                                Text(event.date)

                            }



                            Td(
                                attrs = Modifier
                                    .padding(14.px,16.px)
                                    .then(TableCellStyle.toModifier())
                                    .toAttrs()
                            ) {

                                Text(event.location)

                            }



                            Td(
                                attrs = Modifier
                                    .padding(14.px,16.px)
                                    .width(300.px)
                                    .toAttrs {

                                        style {

                                            property(
                                                "max-width",
                                                "300px"
                                            )

                                            property(
                                                "overflow-wrap",
                                                "break-word"
                                            )

                                        }

                                    }

                            ) {

                                Text(event.description)

                            }



                            Td(
                                attrs = Modifier
                                    .padding(14.px,16.px)
                                    .then(TableCellStyle.toModifier())
                                    .toAttrs()
                            ) {

                                A(
                                    href = event.registrationUrl
                                ) {

                                    Text("Register")

                                }

                            }



                            Td(
                                attrs = Modifier
                                    .padding(14.px,16.px)
                                    .then(TableCellStyle.toModifier())
                                    .toAttrs()
                            ) {


                                Row(
                                    horizontalArrangement = Arrangement.spacedBy(8.px),

                                    verticalAlignment = Alignment.CenterVertically
                                ) {



                                    Button(

                                        modifier = Modifier
                                            .then(EditIconButtonStyle.toModifier())
                                            .then(IconButtonStyle.toModifier()),

                                        onClick = {

                                            selectedEvent = event

                                        }

                                    ) {

                                        FaPen()

                                    }




                                    Button(

                                        modifier = Modifier
                                            .then(DeleteIconButtonStyle.toModifier())
                                            .then(IconButtonStyle.toModifier()),

                                        onClick = {

                                            selectedDeleteEvent = event

                                        }

                                    ) {

                                        FaDeleteLeft()

                                    }


                                }

                            }

                        }

                    }

                }

            }

        }

    }

}